import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { UploadFileRepository } from 'src/app/core/repositories/uploadfile.repository';
// import { CategoryReposiroty } from 'src/app/core/repositories/category.repository';

@Component({
  selector: 'digi-file-upload',
  templateUrl: './input-file-upload.component.html',
  styleUrl: './input-file-upload.component.scss'
})
export class InputFileUploadComponent {
  @Input() text: string = 'LABEL.FILEDINHKEM'
  @Input() isNecessary : boolean = false
  @Input() accept: string = '.doc, .docx, .pdf' // Những định dạng file được phép tải lên 
  @Input() control!: FormControl;           // FormControl để quản lý giá trị và trạng thái
  @Input() isMultiple: boolean = false
  @Input() errMessage: string = ''
  @Input() type: number = 1
  @Input() selectedFiles: any[] = [];
  protected ngUnsubscribeHttp: Subject<void> = new Subject<void>();
  constructor(public uploadFileRepository: UploadFileRepository){}
  onFileSelected(event: any): void {
    const files: FileList = event.target.files;
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      formData.append('files', file, file.name);
    }
    this.uploadFileRepository.uploadFileToS3(formData).pipe(takeUntil(this.ngUnsubscribeHttp))
    .subscribe((res) => {
      if (res.data && res.meta?.error_code === 200) {
        switch(this.isMultiple){
          case true:
            this.selectedFiles =[...this.selectedFiles,...res.data]
            break;
          case false:
            this.selectedFiles =[...res.data]
            break;
        }
        this.control.setValue(this.selectedFiles)
      }
    });
  }
  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.control.setValue(this.selectedFiles)
  }
}
